<template>
	<div style="position: relative;">
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-card >
				<div class="flex text-right">
					<b-button  variant="outline-primary" @click="fetchDrivers" class="my-3">Buscar</b-button>
				</div>

				<div id="drivers-map" ref="drivers-map" class="map"></div>
        </b-card>
		<b-modal v-model="modalShow" v-if="modalShow">
			<b-card class="mb-3 shadow-sm">
				<div class="d-flex align-items-center">
				<!-- Driver Image -->
				<img :src="locationSelected.driver.image" class="rounded-circle mr-3" :alt="driverName" style="width: 80px; height: 80px;">
				<!-- Driver Info -->
				<div>
					<h5 class="mb-0">{{ driverName }}</h5>
					<p class="text-muted mb-2">{{ vehicleDetails}}</p>
					<div>
						<p class="mb-1"><b>Supplier:</b> {{ locationSelected.supplier.name }}</p>
					</div>
					<hr>
					<!-- Last Connection Info -->
					<div>
						<p class="mb-1"><b>Last Connection:</b> {{ formatDate(locationSelected.latest.datetime) }}</p>
						<p class="mb-1"><b>Latitude:</b> {{ locationSelected.latest.latitude }}</p>
						<p class="mb-1"><b>Longitude:</b> {{ locationSelected.latest.longitude }}</p>
					</div>
				</div>
				</div>
			</b-card>
		</b-modal>
	</div>
</template>

<script>
//import Multiselect from 'vue-multiselect'
//import moment from "moment";
import logo from '../../../assets/car-location.png'

export default {
	components: {},
	data() {
		return {
			modalShow:false,
			logo:logo,
			map: null,
			loading:false,
			driversData:[],
			locationSelected:null,
			markers:[],
			cluster:null
		};
	},
	computed: {
		vehicleDetails() {
			const { transportUnit } = this.locationSelected;
			if(this.$root.isEmpty(transportUnit)) return "--";
			return `${transportUnit.name} - Max Passengers: ${transportUnit.maxPassengers} - ID: ${transportUnit.id}`;
		},
		driverName() {
			const { driver } = this.locationSelected;
			return `${driver.firstName} ${driver.lastName}`;
		},
		salesChannelsOpts(){
			return [{group:'SELECT ALL',options: this.$root.auxVars.salesChannelsOpts}]
		}
	},
	methods: {
		addMarkersToCluster(){
			let vars ={
				map:this.map,
				markers:this.markers
			}
			this.cluster = new window.markerClusterer.MarkerClusterer(vars);
		},
		formatDate(datetime) {
			const date = new Date(datetime);
			return date.toLocaleString();
		},
		initMap() {
			if(!this.$root.isEmpty(this.map)){
				console.log("cached");
				return;
			}
			this.map = new window.google.maps.Map(this.$refs["drivers-map"], {
				center: { lat: 21.063954981427, lng:  -86.889645168215 },
				zoom: 11,
				streetViewControl: false,
				styles: [ // Apply custom map styles to create a cleaner look
					{
						featureType: 'poi',
						stylers: [{ visibility: 'off' }] // Hide points of interest
					},
					{
						featureType: 'administrative',
						elementType: 'labels',
						stylers: [{ visibility: 'off' }] // Hide administrative labels
					}
            // Add more custom styles as needed to remove unwanted elements
        ]
			});
		},
		createMarkers(){
			this.driversData.forEach(element => {
				const customIcon = {
					url:this.logo, // URL of the custom icon image
					scaledSize: new window.google.maps.Size(50, 50), // Size of the icon
					origin: new window.google.maps.Point(0, 0), // Position of the icon's origin (top left corner)
					anchor: new window.google.maps.Point(16, 32) // Position of the icon's anchor (center bottom)
				};
				var myLatlng = new window.google.maps.LatLng(parseFloat(element.latest.latitude), parseFloat(element.latest.longitude));
				const marker = new window.google.maps.Marker({
					position: myLatlng,
					icon:customIcon
				});
				marker.addListener("click", () => {
					this.modalShow= true;
					this.locationSelected= element;
					// Open the info window when marker is clicked
					//infoWindow.open(map, marker);
				});
				this.markers.push(marker);
			});

			this.addMarkersToCluster();
			/*var _point = new window.google.maps.LatLng(parseFloat(place.latitude), parseFloat(place.longitude))
			bounds.extend(_point);*/
		},
		clearMarkers(){
			this.markers.forEach((_marker)=>{
				_marker.setMap(null);
			})
			this.markers = [];
			if(this.cluster)this.cluster.clearMarkers();
		},
		fetchDrivers(){
			this.clearMarkers();
			this.loading = true;
			this.$root.api
			.get(`/drivers/realtime`)
			.then(res => {
				this.driversData = res.data;
				this.createMarkers();
			})
			.catch(this.$root.handleRequestError)
			.finally(()=>{
				this.loading = false;
			})
		}
	},
	mounted() {
		//this.initMap();
		this.fetchDrivers();
	},
	destroyed() {
	},
	watch: {}
};
</script>
<style scoped>

#drivers-map {
	width: 100%;
	height: 800px;
}
#zoned-rate-editor .card-body{
    color:black !important
}
</style>


